<template>
    <div class="m-interval"></div>
</template>

<script>
    export default {
        name: "interval"
    }
</script>

<style lang="less">
.m-interval {
    width: 100%;
    height: 16px;
    background: #FAFAFA;
}
</style>